/**
 * Trial status hook — drives the dashboard TrialBanner.
 *
 * Backend GET /trial/status returns one of four states:
 *  - none         : no trial set (existing users, direct signup) → no banner
 *  - active       : days_left > 3 → discreet info banner
 *  - ending_soon  : 1-3 days left → warning banner
 *  - expired      : days_left ≤ 0 → soft-expired banner with contact CTA
 *
 * The query is cached 1 minute — refetched on dashboard mount.
 */
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api';

export type TrialStatus = 'none' | 'active' | 'ending_soon' | 'expired';

export interface TrialStatusResponse {
  status: TrialStatus;
  expires_at: string | null;
  days_left: number | null;
}

export function useTrialStatus() {
  return useQuery<TrialStatusResponse>({
    queryKey: ['trial', 'status'],
    queryFn: () => apiRequest<TrialStatusResponse>('/trial/status'),
    staleTime: 60_000,
  });
}
